import * as levelNames from '../constants/constants';
export const colors = {
    green: "green",
    red: "red",
    black: "black",
    blue: '#4880e4',
    yellow: 'yellow',
    orange: 'orange',
    white: "white",
    cyan: '#4880e4',
}

const randomizeQuestions = (questions) => {
    for(let ctr = 0 ; ctr < questions.length ; ctr++) {
        const newPositionForElement = (Math.floor(Math.random()*1000)) % questions.length;
        const tmp = questions[newPositionForElement];
        questions[newPositionForElement] = questions[ctr];
        questions[ctr] = tmp;
    }
    return questions;
}

export const generateLevelData = () => {
    return Array.from(Array(50).keys()).map(v => {
        const options = ["up", "down", "left", "right"];
        const arrowDirection = (parseInt(Math.random() * 100)) % 4;
        let moveDirection = 0;
        do {
            moveDirection = (parseInt(Math.random() * 100)) % 4
        } while (moveDirection == arrowDirection);

        let type = (parseInt(Math.random() * 100)) % 2

        const optionsAnswers = [
            {
                name: "Up",
                value: 0,
            },
            {
                name: "Down",
                value: 1,
            },
            {
                name: "Left",
                value: 2,
            },
            {
                name: "Right",
                value: 3,
            },
        ]


        return {
            type: levelNames.PONT_OR_MOVE,
            specs: {
                arrowColors: colors.red,
                arrowDirection: options[arrowDirection],
                moveDirection: options[moveDirection],
                type: type ? "moving" : "pointing",
                answer: type ? moveDirection : arrowDirection,
                options: optionsAnswers
            }
        }
    })
}


export const LevelInfo = [
    {
        name: 'Color Match',
        description: <span>Answer a simple question over and over again<br /><div style={{ marginTop: "10px", fontSize: "22px" }}> Does the meaning of the left word match the color of the right word?</div></span>,
        chapter: 1,
    },
    {
        name: 'Crazy Arrows',
        description: 'Think quick and answer a few (not so) simple questions',
        chapter: 2,
    },
];

export default [
    //Level 1 
    randomizeQuestions([
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.green,
                rightColor: colors.red,
                meaningLeft: "black",
                meaningRight: "black",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.blue,
                rightColor: colors.yellow,
                meaningLeft: "yellow",
                meaningRight: "yellow",
                answer: true,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.red,
                rightColor: colors.red,
                meaningLeft: "yellow",
                meaningRight: "yellow",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.orange,
                rightColor: colors.orange,
                meaningLeft: "red",
                meaningRight: "black",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.green,
                rightColor: colors.green,
                meaningLeft: "red",
                meaningRight: "red",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.red,
                rightColor: colors.cyan,
                meaningLeft: "blue",
                meaningRight: "black",
                answer: true,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.red,
                rightColor: colors.yellow,
                meaningLeft: "yellow",
                meaningRight: "red",
                answer: true,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.blue,
                rightColor: colors.yellow,
                meaningLeft: "red",
                meaningRight: "yellow",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.red,
                rightColor: colors.blue,
                meaningLeft: "red",
                meaningRight: "red",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.blue,
                rightColor: colors.yellow,
                meaningLeft: "yellow",
                meaningRight: "yellow",
                answer: true,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.orange,
                rightColor: colors.red,
                meaningLeft: "black",
                meaningRight: "blue",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.blue,
                rightColor: colors.blue,
                meaningLeft: "blue",
                meaningRight: "blue",
                answer: true,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.yellow,
                rightColor: colors.green,
                meaningLeft: "blue",
                meaningRight: "black",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.yellow,
                rightColor: colors.red,
                meaningLeft: "yellow",
                meaningRight: "yellow",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.red,
                rightColor: colors.blue,
                meaningLeft: "blue",
                meaningRight: "blue",
                answer: true,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.orange,
                rightColor: colors.black,
                meaningLeft: "black",
                meaningRight: "red",
                answer: true,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.green,
                rightColor: colors.cyan,
                meaningLeft: "blue",
                meaningRight: "blue",
                answer: true,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.blue,
                rightColor: colors.blue,
                meaningLeft: "yellow",
                meaningRight: "yellow",
                answer: false,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
        {
            type: levelNames.MATCH,
            specs: {
                match: 'meaning',
                with: 'left',
                leftColor: colors.yellow,
                rightColor: colors.yellow,
                meaningLeft: "yellow",
                meaningRight: "yellow",
                answer: true,
                options: [
                    {
                        name: "Match",
                        value: true,
                    },
                    {
                        name: "Not Match",
                        value: false,
                    }
                ]
            }
        },
    ]),

    ///Level 2
    [
        ...generateLevelData(),
    ],
]